import { render, staticRenderFns } from "./reviews-reply.vue?vue&type=template&id=751afe54&scoped=true&"
import script from "./reviews-reply.vue?vue&type=script&lang=js&"
export * from "./reviews-reply.vue?vue&type=script&lang=js&"
import style0 from "./reviews-reply.vue?vue&type=style&index=0&id=751afe54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751afe54",
  null
  
)

export default component.exports